/**
 * Autocomplete option labels must always be strings: MUI's default filterOptions and
 * keyboard navigation call `.toLowerCase()` on every label, so null/undefined/non-string
 * labels crash the render while the popup is open.
 */
export const safeLabel = (label: unknown): string => (label == null ? '' : String(label))
